// =====================================================================
// paginas/notificacoes.js — Chamados abertos pelo inquilino.
//
// Tempo de resposta e de resolução são colunas CALCULADAS pelo banco.
// Ninguém digita, ninguém erra, ninguém "esquece de parar o cronômetro".
// =====================================================================

import { sb } from '../../../../packages/ui/cliente.js';
import { icon, escapeHtml, tabela, badge, modal, checar } from '../ui.js';
import { data } from '../../../../packages/ui/format.js';

const ST = {
  aberto: ['Aberto', 'vermelho'], em_analise: ['Em análise', 'ambar'],
  agendado: ['Agendado', 'azul'], em_execucao: ['Em execução', 'azul'],
  resolvido: ['Resolvido', 'verde'], cancelado: ['Cancelado', 'cinza']
};

export async function pagNotificacoes(el, estado) {
  const lista = checar(await sb.from('chamados')
    .select('*,imoveis(codigo),perfis!chamados_aberto_por_fkey(nome)')
    .order('criado_em', { ascending: false }).limit(200));

  const abertos = lista.filter(c => !['resolvido', 'cancelado'].includes(c.status));
  const resolvidos = lista.filter(c => c.horas_resolucao != null);
  const mediaResp = media(lista.map(c => c.horas_resposta).filter(x => x != null));
  const mediaResol = media(resolvidos.map(c => c.horas_resolucao));

  el.innerHTML = `
    <div class="cabecalho"><h2>Notificações</h2></div>
    <div class="grade k4" style="margin-bottom:20px">
      <div class="cartao kpi ${abertos.length ? 'alerta' : ''}">
        <span class="rotulo">Em aberto</span><span class="valor">${abertos.length}</span></div>
      <div class="cartao kpi"><span class="rotulo">Resolvidos</span>
        <span class="valor">${resolvidos.length}</span></div>
      <div class="cartao kpi"><span class="rotulo">Tempo de 1ª resposta</span>
        <span class="valor">${mediaResp != null ? mediaResp.toFixed(1) + 'h' : '—'}</span>
        <span class="nota">média</span></div>
      <div class="cartao kpi"><span class="rotulo">Tempo de resolução</span>
        <span class="valor">${mediaResol != null ? (mediaResol / 24).toFixed(1) + 'd' : '—'}</span>
        <span class="nota">média</span></div>
    </div>
    <div id="t"></div>`;

  el.querySelector('#t').innerHTML = tabela([
    { th: '#', td: c => `#${c.numero}` },
    { th: 'Imóvel', td: c => escapeHtml(c.imoveis?.codigo || '—') },
    { th: 'Quem abriu', td: c => escapeHtml(c.perfis?.nome || '—') },
    { th: 'Problema', td: c => `<strong>${escapeHtml(c.titulo)}</strong>` },
    { th: 'Categoria', td: c => escapeHtml(c.categoria) },
    { th: 'Aberto em', td: c => data(c.criado_em) },
    { th: '1ª resposta', cls: 'num', td: c => c.horas_resposta != null
        ? badge(`${Number(c.horas_resposta).toFixed(1)}h`, c.horas_resposta > 24 ? 'vermelho' : 'verde')
        : badge('sem resposta', 'vermelho') },
    { th: 'Resolução', cls: 'num', td: c => c.horas_resolucao != null
        ? `${(Number(c.horas_resolucao) / 24).toFixed(1)}d` : '—' },
    { th: 'Situação', td: c => { const [t, k] = ST[c.status] || [c.status, 'cinza']; return badge(t, k); } },
    { th: '', cls: 'acoes', td: c => `<button class="icone" data-ed="${c.id}">${icon('editar')}</button>` }
  ], lista, 'Nenhum chamado.');

  el.querySelectorAll('[data-ed]').forEach(b => b.onclick = () => {
    const c = lista.find(x => x.id === b.dataset.ed);
    modal({
      titulo: `Chamado #${c.numero} — ${c.titulo}`,
      dados: c,
      campos: [
        { nome: 'status', label: 'Situação', tipo: 'select',
          opcoes: ['aberto', 'em_analise', 'agendado', 'em_execucao', 'resolvido', 'cancelado'] },
        { nome: 'prioridade', label: 'Prioridade', tipo: 'select',
          opcoes: ['baixa', 'media', 'alta', 'urgente'] },
        { nome: 'custo', label: 'Custo', tipo: 'number', step: '0.01' },
        { nome: 'responsavel_pagamento', label: 'Quem paga', tipo: 'select',
          opcoes: ['', 'proprietario', 'inquilino', 'imobiliaria', 'condominio'] },
        { nome: 'parecer', label: 'Parecer', tipo: 'textarea', full: true }
      ],
      onSalvar: async (d) => {
        const patch = { ...d, custo: d.custo ? Number(d.custo) : null };
        // Primeira resposta: registra o instante uma vez só. É o que
        // torna o indicador honesto.
        if (!c.primeira_resposta_em) patch.primeira_resposta_em = new Date().toISOString();
        if (d.status === 'resolvido' && !c.resolvido_em) patch.resolvido_em = new Date().toISOString();
        checar(await sb.from('chamados').update(patch).eq('id', c.id));
        pagNotificacoes(el, estado);
      }
    });
  });
}

const media = (a) => a.length ? a.reduce((s, x) => s + Number(x), 0) / a.length : null;
